import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useRouteParams } from '../hooks/useRouteParams';

interface CancelScheduledTransferParams {
  scheduledTransferId: string;
}

const cancelScheduledTransfer = ({
  clientId,
  managedAccountId,
}: {
  clientId: string;
  managedAccountId: string;
}) => ({ scheduledTransferId }: CancelScheduledTransferParams) =>
  authFetch(
    urlWithParams(
      '/Consumer/AchScheduledTransfers/Cancel',
      {
        clientId,
        managedAccountId,
      },
      { skipNulls: true },
    ),

    {
      method: 'POST',
      ...httpBodyOptions({ managedAccountId, scheduledTransferId }, true),
    },
  );

export const useCancelScheduledTransferMutation = (managedAccountId: string) => {
  const { clientId } = useRouteParams();

  const queryClient = useQueryClient();

  const queryKey = queryKeys.scheduledTransfers({ clientId, managedAccountId });

  return useMutation(cancelScheduledTransfer({ clientId, managedAccountId }), {
    onSuccess(data) {
      queryClient.setQueryData(queryKey, data);
    },
  });
};
